import React from "react";
import { useLocation } from "react-router-dom";
import { MultipleChoice, MultipleSelection, Question, Rating, Scale, YesNo } from "../types";
import MultipleChoiceOptionsResponseDisplay from "./MultipleChoiceOptionsResponseDisplay";
import MultipleSelectionOptionsResponseDisplay from "./MultipleSelectionOptionsResponseDisplay";
import RatingResponseDisplay from "./RatingResponseDisplay";
import DropdownSelectionOptionsResponseDisplay from "./DropdownSelectionOptionsResponseDisplay";
import ShortResponseResponseDisplay from "./ShortResponseResponseDisplay";
import ScaleResponseDisplay from "./ScaleResponseDisplay";
import YesNoResponseDisplay from "./YesNoResponseDisplay";

interface QuestionPreviewDisplayProps {
    question: Question;
}

export default (props: QuestionPreviewDisplayProps) => {

    const { question } = props;
    const pathName = useLocation().pathname.split('/')[1];

    

    return (
        <div className="flex flex-col w-full p-1 md:p-5 md:w-11/12 min-h-48 md:min-h-96 border border-stone-500 rounded-lg md:rounded-3xl shadow-black shadow-md capitalize">
            {question.type === 'Multiple Choice' && (
                <div>
                    <MultipleChoiceOptionsResponseDisplay question={question} questionText={question.questionText} options={(question.questionBody as MultipleChoice).options} />
                </div>
            )}
            {question.type === 'Multiple Selection' && (
                <div>
                    <MultipleSelectionOptionsResponseDisplay question={question} questionText={question.questionText} options={(question.questionBody as MultipleSelection).options} />
                </div>
            )}
            {
                question.type === 'Dropdown Selection' && (
                <div>
                    <DropdownSelectionOptionsResponseDisplay question={question} questionText={question.questionText} options={(question.questionBody as MultipleSelection).options} />
                </div>
            )}
            {question.type === 'Short Response' && (
                <div>
                    <ShortResponseResponseDisplay question={question} questionText={question.questionText} options={[]}/>
                </div>
            )}
            {question.type === 'Scale' && (
                <div>
                    <ScaleResponseDisplay question={question} questionText={question.questionText} questionBody={(question.questionBody as Scale)} />
                </div>
            )}
            {question.type === 'Rating' && (
                <div>
                    <RatingResponseDisplay question={question} questionText={question.questionText} questionBody={(question.questionBody as Rating)} />
                </div>
            )}
            {question.type === 'YesNo' && (
                <div>
                    <YesNoResponseDisplay question={question} questionText={question.questionText} options={(question.questionBody as YesNo).options} />
                </div>
            )}
        </div>
    )
}